const hues = Array.from({ length: 8 }, (_, i) => i * (360 / 8))

export function generateMarkerFilter(locationIndex: number) {
	const hue = hues[locationIndex % hues.length]
	return `hue-rotate(${hue}deg) brightness(110%)`
}
